(function () {
  const triggers = document.querySelectorAll('[data-artwork-lightbox-trigger]');
  const preloadedImages = [];

  const preloadFullImages = () => {
    const imageUrls = new Set(Array.from(triggers, (trigger) => trigger.dataset.fullImage).filter(Boolean));

    imageUrls.forEach((imageUrl) => {
      const image = new Image();
      image.src = imageUrl;
      preloadedImages.push(image);
    });
  };

  if (document.readyState === 'complete') {
    preloadFullImages();
  } else {
    window.addEventListener('load', preloadFullImages, { once: true });
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const lightboxRoot = trigger.closest('[data-lightbox-root]');
      const lightbox = lightboxRoot?.querySelector('[data-artwork-lightbox]');
      const image = lightbox?.querySelector('[data-artwork-lightbox-image]');

      if (!lightbox || !image) return;

      image.src = trigger.dataset.fullImage;
      image.alt = trigger.dataset.imageAlt || '';
      lightbox.showModal();
      lightbox.focus({ preventScroll: true });
    });
  });

  document.querySelectorAll('[data-artwork-lightbox]').forEach((lightbox) => {
    lightbox.querySelector('[data-artwork-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
  });

  document.querySelectorAll('[data-artwork-viewer]').forEach((viewer) => {
    const previous = viewer.querySelector('[data-artwork-viewer-previous]');
    const next = viewer.querySelector('[data-artwork-viewer-next]');
    const close = viewer.querySelector('[data-artwork-viewer-close]');

    close?.addEventListener('click', (event) => {
      if (!close.dataset.artworkCollectionPath || !document.referrer) return;

      const referringUrl = new URL(document.referrer);
      const arrivedFromCollection =
        referringUrl.origin === window.location.origin &&
        referringUrl.pathname === close.dataset.artworkCollectionPath;

      if (arrivedFromCollection) {
        event.preventDefault();
        window.history.back();
      }
    });

    document.addEventListener('keydown', (event) => {
      const openLightbox = viewer.querySelector('[data-artwork-lightbox][open]');
      if (openLightbox) return;

      if (event.key === 'ArrowLeft' && previous) {
        window.location.assign(previous.href);
      } else if (event.key === 'ArrowRight' && next) {
        window.location.assign(next.href);
      } else if (event.key === 'Escape' && close) {
        close.click();
      }
    });
  });
})();
